let cachedClipboardText = "";
let cachedClipboardValue = "";

function normalizeClipboardText(value) {
	if (typeof value === "string") {
		return value;
	}
	if (value === null || typeof value === "undefined") {
		return "";
	}
	try {
		return JSON.stringify(value);
	} catch (err) {
		return String(value);
	}
}

const initializeClipboardCache = () => {
	if (navigator?.clipboard?.readText) {
		navigator.clipboard.readText().then((text) => {
			if (typeof text === "string") {
				cachedClipboardText = text;
				cachedClipboardValue = text;
			}
		}).catch(() => {
			// ignore - clipboard permissions not granted
		});
	}
};

initializeClipboardCache();

let toastHandler = null;

export function registerClipboardToastCallback(callback) {
	toastHandler = callback;
}

function triggerToast() {
	if (typeof toastHandler === "function") {
		try {
			toastHandler();
		} catch (err) {
			console.warn("Clipboard toast callback failed", err);
		}
	}
}

export async function copyToClipboard(text) {
	const normalizedText = normalizeClipboardText(text);
	cachedClipboardText = normalizedText;
	cachedClipboardValue = text === null || typeof text === "undefined" ? "" : text;

	if (navigator?.clipboard?.writeText) {
		try {
			await navigator.clipboard.writeText(normalizedText);
			triggerToast();
			return true;
		} catch (err) {
			console.warn("navigator.clipboard.writeText failed", err);
		}
	}

	try {
		const textarea = document.createElement("textarea");
		textarea.value = normalizedText;
		textarea.setAttribute("readonly", "");
		textarea.style.position = "fixed";
		textarea.style.opacity = "0";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		const succeeded = document.execCommand("copy");
		document.body.removeChild(textarea);
		if (succeeded) {
			triggerToast();
		}
		return succeeded;
	} catch (err) {
		console.warn("Fallback clipboard copy failed", err);
		return false;
	}
}

export const copy = copyToClipboard;

export async function readClipboardText() {
	if (navigator?.clipboard?.readText) {
		try {
			const text = await navigator.clipboard.readText();
			if (typeof text === "string") {
				cachedClipboardText = text;
				cachedClipboardValue = text;
				return text;
			}
		} catch (err) {
			console.warn("navigator.clipboard.readText failed", err);
		}
	}
	return cachedClipboardText;
}

export function getClipboard() {
	return cachedClipboardValue;
}

export function isClipboardEmpty() {
	return cachedClipboardValue === null || typeof cachedClipboardValue === "undefined" || cachedClipboardValue === "";
}
